import { render, staticRenderFns } from "./FacebookBrands.vue?vue&type=template&id=5551fece"
import script from "./FacebookBrands.vue?vue&type=script&lang=ts"
export * from "./FacebookBrands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports